import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MitsIconName } from 'src/packages/shared-ui';
import {
  SelectableHTMLElement,
  SelectableType,
  SelectedEvent,
} from '../../types';
import { IChecklistGroup } from './../../models/checklist-group';
import { TranslatePipe } from 'src/packages/shared-ui';

@Component({
  selector: 'ch-group',
  templateUrl: './ch-group.component.html',
  styleUrls: ['./ch-group.component.scss'],
  providers: [TranslatePipe],
})
export class ChGroupComponent {
  @Input() group!: IChecklistGroup;
  @Output() selected: EventEmitter<SelectedEvent> =
    new EventEmitter<SelectedEvent>();

  expanded = false;

  @Input()
  public icon: MitsIconName = 'list';

  constructor(private readonly translatePipe: TranslatePipe<IChecklistGroup>) {}

  /** Titel in der aktuellen App-Sprache, Fallback auf den Basistitel. */
  get displayTitle(): string {
    return this.translatePipe.transform(this.group, 'title');
  }

  toggleExpand(ev: Event) {
    ev.stopPropagation();
    this.expanded = !this.expanded;
  }

  select(
    htmlElement: SelectableHTMLElement,
    selected: SelectableType,
    ev: Event
  ) {
    ev.stopPropagation();
    this.selected.emit({
      htmlElement,
      item: selected,
      clickEvent: ev,
    });
  }
}
